import api from './API'

const ORGANISATIONS_URL = '/organisations'

export default {
  list: function (organisationId) {
    const url = `${ORGANISATIONS_URL}/${organisationId}/accounts`
    return api.newRequest('get', url)
  },
  create: function (organisationId, payload) {
    const url = `${ORGANISATIONS_URL}/${organisationId}/accounts`
    return api.newRequest('post', url, payload)
  },
  update: function (organisationId, accountId, payload) {
    const url = `${ORGANISATIONS_URL}/${organisationId}/accounts/${accountId}`
    return api.newRequest('patch', url, payload)
  },
  delete: function (organisationId, accountId) {
    const url = `${ORGANISATIONS_URL}/${organisationId}/accounts/${accountId}`
    return api.newRequest('delete', url)
  },
  reinvite: function (organisationId, accountId) {
    const url = `${ORGANISATIONS_URL}/${organisationId}/accounts/${accountId}/reinvite`
    return api.newRequest('post', url)
  }
}
